import React from 'react';

// Two crossing palm trees over a small pond, echoing the physical card's
// back design -- kept to black/white only so it reads cleanly at small
// sizes on top of the card's orange fill.
export default function CardBackDesign() {
  const leftCrown = [
    'M15,15 L2,4',
    'M15,15 L0,14',
    'M15,15 L1,26',
    'M15,15 L12,30',
    'M15,15 L24,29',
    'M15,15 L30,20',
    'M15,15 L30,8',
  ];
  const rightCrown = [
    'M85,15 L98,4',
    'M85,15 L100,14',
    'M85,15 L99,26',
    'M85,15 L88,30',
    'M85,15 L76,29',
    'M85,15 L70,20',
    'M85,15 L70,8',
  ];

  return (
    <svg viewBox="0 0 100 100" className="card-back-design" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M20,88 Q30,80 40,86 Q50,80 60,86 Q70,80 80,88 Q75,96 60,94 Q50,98 40,94 Q25,96 20,88 Z"
        fill="#000"
      />
      <path
        d="M25,89 Q35,85 45,89 Q55,85 65,89 Q72,86 75,89"
        fill="none"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      <path d="M15,15 C60,40 20,60 50,90" fill="none" stroke="#000" strokeWidth="7" strokeLinecap="round" />
      <path
        d="M15,15 C60,40 20,60 50,90"
        fill="none"
        stroke="#fff"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        strokeLinecap="round"
      />
      <path d="M85,15 C40,40 80,60 50,90" fill="none" stroke="#000" strokeWidth="7" strokeLinecap="round" />
      <path
        d="M85,15 C40,40 80,60 50,90"
        fill="none"
        stroke="#fff"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        strokeLinecap="round"
      />

      <g stroke="#000" strokeWidth="5" strokeLinecap="round">
        {leftCrown.map(d => <path key={d} d={d} />)}
      </g>
      <g stroke="#fff" strokeWidth="1.5" strokeLinecap="round">
        {leftCrown.map(d => <path key={d} d={d} />)}
      </g>

      <g stroke="#000" strokeWidth="5" strokeLinecap="round">
        {rightCrown.map(d => <path key={d} d={d} />)}
      </g>
      <g stroke="#fff" strokeWidth="1.5" strokeLinecap="round">
        {rightCrown.map(d => <path key={d} d={d} />)}
      </g>
    </svg>
  );
}
